import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';

/**
 * CommandCenterHeader — sticky top bar that matches the Home page:
 *   - Stewie logo + "AskStewie" wordmark that route to "/"
 *   - Back button that goes to the previous page with "/" fallback
 *   - Current user name/email (hidden on very small screens)
 *   - Sign Out
 * Deliberately a SEPARATE component (not the app-wide sidebar) because
 * the spec explicitly forbids duplicate navigation bars — this replaces
 * the ad-hoc header that was inline in HomeCommandCenter.jsx.
 */
export default function CommandCenterHeader({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  function goHome(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate('/');
  }

  function goBack() {
    if (window.history.length > 1 && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/');
    }
  }

  const label = user?.name || user?.email || '';

  return (
    <header className="cc-header" data-testid="cc-header">
      <div className="cc-header-inner">
        <button
          type="button"
          className="cc-header-back"
          onClick={goBack}
          aria-label="Go back"
          data-testid="cc-header-back"
        >
          <ArrowLeft size={16} strokeWidth={2.2} />
          <span>Back</span>
        </button>

        <a
          href="/"
          onClick={goHome}
          className="cc-header-logo"
          data-testid="cc-header-logo"
          aria-label="Go to home"
        >
          <img src="/stewie_front.png" alt="" />
          <span className="cc-header-logo-text">AskStewie</span>
        </a>

        <div className="cc-header-spacer" />

        {label && (
          <span className="cc-header-user" data-testid="cc-header-user">
            {label}
          </span>
        )}

        <button
          type="button"
          className="cc-header-signout"
          onClick={onLogout}
          data-testid="cc-header-signout"
          aria-label="Sign out"
        >
          <LogOut size={13} strokeWidth={2.4} />
          <span style={{ marginLeft: 6 }}>Sign Out</span>
        </button>
      </div>
    </header>
  );
}
